import { NgTemplateOutlet } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

import {
  ButtonModule,
  ButtonSize,
  ButtonType,
  IconModule,
} from '@hglobal/fin-ui';

@Component({
  imports: [ButtonModule, IconModule, NgTemplateOutlet],
  selector: 'iw-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled()',
  },
})
export class ButtonComponent {
  size = input<ButtonSize>('m');
  uiType = input<ButtonType>('primary');
  iconName = input<string>('');
  onlyIcon = input(false, { transform: booleanAttribute });
  isPressed = input(false, { transform: booleanAttribute });
  disabled = input(false, { transform: booleanAttribute });
  fullWidth = input(false, { transform: booleanAttribute });
  iconPosition = input<'left' | 'right'>('right');

  clicked = output<MouseEvent>();

  onClick(event: MouseEvent): void {
    if (!this.disabled()) {
      this.clicked.emit(event);
    }
  }
}
